import $ from 'jquery';
import ga from '../../vendor/google-analytics';

export default function bindHistoryToSubnav(history) {
  function highlightSubnavForPath(path) {
    let subpath = path.split('/')[2];

    if (subpath !== 'schedule' && subpath !== 'about') {
      subpath = 'watch';
    }

    let rgx = new RegExp(subpath + '/$', 'i');

    $('.sub-navigation-link').each(function(i, elm) {
      let $elm = $(elm);
      $elm.parent().toggleClass('active', ($elm.html().trim() + '/').search(rgx) !== -1);
    })
  }

  $('body').on(
    'click',
    '.sub-navigation-link',
    function(e) {
      let label = $(this).html().trim();

      if (label === 'Watch' || label === 'Schedule' || label === 'About') {
        e.preventDefault();

        let path = $(this)[0].pathname;

        ga('send', 'event', 'Show | Subnav', 'Click ' + label, window.location.href);

        highlightSubnavForPath(path);
        history[window.location.pathname !== path ? 'push' : 'replace'](path);
      }
    }
  );

  $(window).on('popstate', function() {
    highlightSubnavForPath(window.location.pathname);
  });
}